import { all } from 'redux-saga/effects'
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducers from '../../reducers'
import { fetchAfterExpiryTimeWatcher } from './ExTime.saga'
import { cartWatcher } from './Cart.saga'
import { orderWatcher } from './Order.saga'

function* rootSaga() {
  yield all([
    fetchAfterExpiryTimeWatcher(),
    cartWatcher(),
    orderWatcher()
  ])
}

const sagaMiddleware = createSagaMiddleware()
const store = createStore(rootReducers, applyMiddleware(sagaMiddleware))

export { sagaMiddleware, store, rootSaga }
